import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './ToyReadyModal.css'

type Props = {
  open: boolean
}

export default function ToyReadyModal({ open }: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const dlg = dialogRef.current
    if (!dlg) return
    if (open && !dlg.open) dlg.showModal()
    if (!open && dlg.open) dlg.close()
  }, [open])

  return (
    <dialog
      ref={dialogRef}
      className="toy-ready-modal"
      onCancel={(e) => e.preventDefault()}
    >
      <div className="toy-ready-modal__body">
        <h2 className="toy-ready-modal__title">Your toy is ready</h2>
        <p className="toy-ready-modal__lede">
          We&rsquo;ve packaged everything up. Head back to your Toys page to install it on your
          device.
        </p>
        <div className="toy-ready-modal__actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate('/')}
            autoFocus
          >
            Back to Toys
          </button>
        </div>
      </div>
    </dialog>
  )
}
